import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DefaultValueAccessor } from '@angular/forms';

@Directive({
  selector: 'input[postcodeFormat]',
})
export class PostcodeFormatDirective extends DefaultValueAccessor {
  @Input('postcodeFormat') postcodeFormat: string;

  // this property is necessary to update the model.
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  @HostListener('blur', ['$event.type', '$event.target.value'])
  onInput(event: string, value: string): void {
    if (value.indexOf('*') >= 0 || value.length <= 4) {
      value = value.toUpperCase();
    } else {
      value = value.replace(/ /g, '');
      value = value.replace(/(?=.{3}$)/, ' ');
      value = value.toUpperCase();
    }

    this.ngModelChange.emit(value);

    // update element
    this.writeValue(value);
  }
}
